import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Courses from "./pages/Courses";
import Faculty from "./pages/Faculty";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/sonner";
import TutorWave from "./pages/TutorWave";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes with header/footer */}
          <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/courses" element={<><Header /><Courses /><Footer /></>} />
          <Route path="/faculty" element={<><Header /><Faculty /><Footer /></>} />
          <Route path="/gallery" element={<><Header /><Gallery /><Footer /></>} />
          <Route path="/blog" element={<><Header /><Blog /><Footer /></>} />
          <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
          <Route path="/tutorwave" element={<TutorWave />} />
          
          {/* Admin routes without header/footer */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>

        {/* Floating WhatsApp Button */}
        <a
          href="https://wa.me/917004929531?text=Hello%20I%20want%20to%20enquire%20about%20admissions%20at%20The%20Lighthouse%20Coaching%20Institute"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: "#25D366",
            color: "white",
            padding: "12px 18px",
            borderRadius: "50px",
            textDecoration: "none",
            fontWeight: "bold",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            zIndex: 1000
          }}
        >
          WhatsApp Us
        </a>

        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
